import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import FlagIcon from '@mui/icons-material/Flag';
import CancelIcon from '@mui/icons-material/Cancel';
import { Typography } from '@mui/material';
import { UserAccount } from '../../../data/models/user-account.model';

const PREFIX = 'StatusIndicator';

const classes = {
  legend: `${PREFIX}-legend`,
  ok: `${PREFIX}-ok`,
  warn: `${PREFIX}-warn`,
  alert: `${PREFIX}-alert`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`& .${classes.legend}`]: {
    display: 'flex',
    alignContent: 'flex-end',
    justifyContent: 'flex-start',
  },

  [`& .${classes.ok}`]: {
    color: theme.palette.success.main,
    marginRight: theme.spacing(1),
  },

  [`& .${classes.warn}`]: {
    color: theme.palette.warning.main,
    marginRight: theme.spacing(1),
  },

  [`& .${classes.alert}`]: {
    color: theme.palette.error.main,
    marginRight: theme.spacing(1),
  },
}));

interface StatusIndicatorProps {
  user: UserAccount;
}

const Legend = () => {
  const { t } = useTranslation('common');

  return (
    <StyledBox>
      <Box className={classes.legend} component="div">
        <FlagIcon className={classes.ok} />{' '}
        <Typography>{t('common.active')}</Typography>
      </Box>
      <Box className={classes.legend} component="div">
        <CancelIcon className={classes.alert} />
        <Typography>{t('common.inactive')}</Typography>
      </Box>
    </StyledBox>
  );
};

export default function StatusIndicator({ user }: StatusIndicatorProps) {
  const active =
    user.userAccountState === 'active' && !user.isPasswordTemporary;

  return (
    <StyledBox>
      <Tooltip title={<Legend />}>
        {active ? (
          <FlagIcon data-testid="flag" className={classes.ok} />
        ) : (
          <CancelIcon data-testid="cancel" className={classes.alert} />
        )}
      </Tooltip>
    </StyledBox>
  );
}
